import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
  CategoriaAdminComponent,
  CategoriaEditComponent,
  CategoriaNewComponent,
  SubcategoriaAdminComponent, SubcategoriaEditComponent, SubcategoriaNewComponent
} from './components/admin/categoria.admin.component';
import {PreguntasAdminComponent, PreguntasEditComponent, PreguntasNewComponent} from './components/admin/preguntas.admin.component';
import {PlantillaEditComponent, PlantillaNewComponent, PlantillasAdminComponent} from './components/admin/plantillas.admin.component';
import {VisitaAdminComponent} from './components/admin/visita.admin.component';
import {ListVisitasComponent, EditVisitaComponent, VisitaComponent} from './components/visita.component';
import {RvgSecurityServices} from './services/rvg.security.services';


const appRoutes: Routes = [
  {path: 'admin/rvg/categorias', component: CategoriaAdminComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/categorias/edit/:id', component: CategoriaEditComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/categorias/new', component: CategoriaNewComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/subcategorias', component: SubcategoriaAdminComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/subcategorias/edit/:id', component: SubcategoriaEditComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/subcategorias/new', component: SubcategoriaNewComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/preguntas', component: PreguntasAdminComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/preguntas/edit/:id', component: PreguntasEditComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/preguntas/new', component: PreguntasNewComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/plantillas', component: PlantillasAdminComponent, canActivate: [RvgSecurityServices]},
  // {path: 'admin/rvg/plantillas/edit/:id', component: PlantillaEditComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/plantillas/new', component: PlantillaNewComponent, canActivate: [RvgSecurityServices]},
  {path: 'admin/rvg/visitas', component: VisitaAdminComponent, canActivate: [RvgSecurityServices]},
  {path: 'visitas', component: ListVisitasComponent, canActivate: [RvgSecurityServices]},
  {path: 'visitas/edit/:id', component: EditVisitaComponent, canActivate: [RvgSecurityServices]},
  {path: 'visitas/view/:id', component: VisitaComponent, canActivate: [RvgSecurityServices]}
];

@NgModule({
  imports: [RouterModule.forChild(appRoutes)],
  exports: [RouterModule]
})
export class RvgRoutingModule {

}
